module.exports = __webpack_public_path__ + "static/media/close-icon.0752876d.svg";